import { defineStore } from 'pinia';
import { apiPost } from '../services/api';

export const useCommonStore = defineStore('common', {
    state: () => ({
        branches: [],
        userLevels: [],
        positions: [],
        lowStockItems: [],
        loading: false
    }),
    actions: {
        async fetchBranches() {
            if (this.branches.length > 0) return;
            try {
                const data = await apiPost('common', 'getBranches');
                this.branches = data;
            } catch (err) {
                console.error('Failed to fetch branches');
            }
        },
        async fetchUserLevels() {
            if (this.userLevels.length > 0) return;
            try {
                const data = await apiPost('common', 'getUserLevel');
                this.userLevels = data;
            } catch (err) {
                console.error('Failed to fetch user levels');
            }
        },
        async fetchPositions() {
            if (this.positions.length > 0) return;
            try {
                const data = await apiPost('common', 'getEmpPosition');
                this.positions = data;
            } catch (err) {
                console.error('Failed to fetch positions');
            }
        },
        async fetchLowStockItems(branch_cd) {
            if (!branch_cd) return [];
            try {
                const data = await apiPost('inventory', 'getLowStockItems', { branch_cd: branch_cd });
                if (data) {
                    const existingIds = this.lowStockItems.map(i => i.item_no);
                    const newlyAdded = data.filter(i => !existingIds.includes(i.item_no));
                    
                    this.lowStockItems = data;
                    return newlyAdded; // Return new ones so Navbar can toast them
                }
            } catch (err) {
                console.error('Failed to fetch low stock alerts', err);
            }
            return [];
        }
    }
});
